// BV - refresh cart after gwp product is added
(function() {
  document.documentElement.addEventListener('free-gift:added', (e) => {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true, detail: { open: true }
    }));
  });
})();

// BV - remove gwp products from cart if below gift threshold
(async function() {
  let gwpThreshold = window.BONFIRE?.gwp_settings?.threshold || false;

  let updateGWP = async (e) => {
    setTimeout(async () => {
      let cartRequest = await fetch('/cart.js');
      let cart = await cartRequest.json();
      
      let cartTotal = 0;
      let gwpLineItem;

      cart.items.forEach((item) => {
        if (item.requires_shipping) {
          cartTotal += item.line_price;
        }

        if (item.properties['_gwp'] === 'true') {
          gwpLineItem = item;
        }
      });

      cartTotal = cartTotal - cart.total_discount;

      if (gwpThreshold && cartTotal < gwpThreshold && gwpLineItem) {
        let requestData = {
          id: gwpLineItem.key,
          quantity: 0
        };

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData)
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true, detail: { open: true }
        }));
      }
    }, 200);
  }

  document.addEventListener('cart:quantity-updated', () => {
    setTimeout(() => updateGWP(null), 1000);
    setTimeout(() => updateGWP(null), 3000);
  });
  document.addEventListener('ajaxProduct:added', updateGWP);
  updateGWP(null);
})();